module.exports = __webpack_public_path__ + "img/geschmiedetestreppengelaender.d7bf6bc0.jpg";